module.exports = {"131124100":"饶阳镇","131124101":"大尹村镇","131124102":"五公镇","131124103":"大官亭镇","131124200":"王同岳乡","131124202":"留楚乡","131124203":"东里满乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/131124.json
// module id = 221
// module chunks = 0